import { Field, Label } from "V2.0/common/fieldset";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";
import { CompletionStatus } from "../../../Models/End";

export default DefaultEndForm;

const completionStatusOptions = [
  { id: 0, value: CompletionStatus.COMPLETED, label: "Completed" },
  { id: 1, value: CompletionStatus.FAILED, label: "Failed" },
  { id: 2, value: CompletionStatus.CANCELLED, label: "Cancelled" },
];

function DefaultEndForm(props) {
  const { formState, errors, updateFormState } = props;

  return (
    <div>
      <Field>
        <Label>Completion Status</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.completionStatus}
          defaultValue={formState.completionStatus}
          invalid={!!errors.completionStatus}
          onChange={(value) => updateFormState("completionStatus", value)}
        >
          {completionStatusOptions.map((option) => {
            return <ListboxOption
              key={option.id}
              value={option.value}
            >
              <ListboxLabel>{option.label}</ListboxLabel>
            </ListboxOption>;
          })}
        </Listbox>
      </Field>
    </div>
  );
}
